<template>
  <nav>
    <ul class="pagination">
      <li class="page-item" :class="{ disabled: previousPage === null }">
        <router-link
          :to="previousPage !== null ? url(previousPage) : ''"
          class="page-link"
          aria-label="Назад"
        >
          <span aria-hidden="true">&laquo;</span>
        </router-link>
      </li>

      <li
        v-for="page of visiblePages"
        :key="page"
        class="page-item"
        :class="{ active: page == currentPage }"
      >
        <router-link
          :to="url(page)"
          class="page-link"
        >
          {{ page }} <span v-if="page == currentPage" class="sr-only">(current)</span>
        </router-link>
      </li>

      <li class="page-item" :class="{ disabled: nextPage === null }">
        <router-link
          :to="nextPage !== null ? url(nextPage) : ''"
          class="page-link"
          aria-label="Вперед"
        >
          <span aria-hidden="true">&raquo;</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    url: {
      type: Function
    }
  },
  computed: {
    visiblePages () {
      const pages = []
      for (let i = 1; i <= this.pageCount; ++i) {
        pages.push(i)
      }
      return pages
    },
    previousPage () {
      if (this.currentPage <= 1) {
        return null
      }
      return this.currentPage - 1
    },
    nextPage () {
      if (this.currentPage >= this.pageCount) {
        return null
      }
      return this.currentPage + 1
    }
  }
}
</script>

<style scoped>
  .pagination {
    user-select: none;
  }
</style>
